import React, { useState } from 'react'
import StatBadge from '../../components/Atoms/State Badge/StatBadge';
import Pending from './Components/Pending';
import Approve from './Components/Approve';
import Decline from './Components/Decline';
import MoreInfoRequired from './Components/MoreInfoRequired';

const RestrictAcctUnusualActivity = () => {
    const [activeTab, setActiveTab] = useState('Pending');
    const records = [
        {
            name: "Huzaifa Khan",
            dob: "Feb 15, 2025",
            email: "huzaifa@gmail.com",
            hugs: 89,
            extraHugs: 20,
            time: "12:254:12:200",
            country: "UK",
            documentType: "Driver's License",
            issuingState: "Ohio",
            licenseNumber: "AB123456",
            expiryDate: "12/10/2026",
            idNumber: "36985214758",
            address: "302/ C-scheme Jaipur, Rajasthan, India, 302001",
            amountDue: "$000.00",
            reason: "Your ID card is not correct"
        },
        {
            name: "Huzaifa Khan",
            dob: "Feb 15, 2025",
            email: "huzaifa@gmail.com",
            hugs: 89,
            extraHugs: 20,
            time: "12:254:12:200",
            country: "UK",
            documentType: "Driver's License",
            issuingState: "Ohio",
            licenseNumber: "AB123456",
            expiryDate: "12/10/2026",
            idNumber: "36985214758",
            address: "302/ C-scheme Jaipur, Rajasthan, India, 302001",
            amountDue: "$000.00",
            reason: "Your ID card is not correct"

        },
    ];


    const stats = {
        'Pending': 109,
        'Approved': 109092,
        'Declined': 90,
        'More Info Required': 20,
    };

    const renderData = () => {
        switch (activeTab) {
            case 'Pending':
                return <div className="p-3"><Pending data={records} /></div>;
            case 'Approved':
                return <div className="p-3"><Approve data={records} /></div>;
            case 'Declined':
                return <div className="p-3"><Decline data={records} /></div>;
            case 'More Info Required':
                return <div className="p-3"><MoreInfoRequired data={records} /></div>;
            default:
                return null;
        }
    };

    return (
        <div className='p-3 h-screen overflow-hidden overflow-y-auto'>
            <div className='p-4 overflow-auto overflow-y-auto'>
                <div className="p-3">
                    <div className=" flex flex-col md:flex-row justify-between items-center">
                        <h1 className="text-xl font-bold text-gray-800">Restrict Account Unusual Activity (100,092)</h1>
                        <div className="flex flex-wrap gap-2 mt-2 md:mt-0">
                            {Object.entries(stats).map(([key, value]) => (
                                <StatBadge
                                    key={key}
                                    label={`${key.charAt(0).toUpperCase() + key?.slice(1)} : ${value}`}
                                    isActive={activeTab === key.charAt(0).toUpperCase() + key?.slice(1)}
                                    onClick={() => setActiveTab(key.charAt(0).toUpperCase() + key?.slice(1))}
                                />
                            ))}
                        </div>
                    </div>
                </div>
                {renderData()}
            </div>
        </div>
    )
}

export default RestrictAcctUnusualActivity